import type { SxProps, Theme } from "@mui/material";
import appTheme from "../../theme";

// 2px border, defaults to theme divider
const B = (c?: string) => `2px solid ${c ?? appTheme.palette.divider}`;

const pillBase: SxProps<Theme> = {
    fontWeight: 900,
    letterSpacing: 0.4,
    borderRadius: 5,
    py: 0.5,
    textAlign: "center",
    border: B(),
    display: "block",
};

const btnBase: SxProps<Theme> = {
    ...pillBase,
    py: 0.75,
    fontSize: 16,
    bgcolor: appTheme.palette.background.paper,
    color: appTheme.palette.text.primary,
    userSelect: "none",
    transition: "transform .05s",
    cursor: "pointer",
    "&:active": { transform: "translateY(1px)" },
};

export const sx = {
    page: { p: { xs: 2, md: 3 }, background: "transparent", boxShadow: "none" },
    grid: { display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: { xs: 2, md: 3 } },
    head: {
        bgcolor: appTheme.palette.common.black,
        color: appTheme.palette.common.white,
        px: 2,
        py: 1,
        fontWeight: 800,
        fontSize: { xs: 16, md: 18 },
        lineHeight: 1.2,
    },
    body: (subscribed?: boolean): SxProps<Theme> => ({
        display: "grid",
        gridTemplateColumns: "1fr auto",
        gap: 2,
        p: 2,
        alignItems: "center",
        mixBlendMode: subscribed ? "normal" : "luminosity",
        borderTop: `1px solid ${appTheme.palette.secondary.main}`,
        // filter: "grayscale(100%)"
    }),
    art: {
        minHeight: 160,
        borderRadius: appTheme.shape.borderRadius * 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    col: { display: "flex", flexDirection: "column", gap: 1, minWidth: 150 },
    dot: {
        position: "absolute",
        right: 8,
        top: "50%",
        transform: "translateY(-50%)",
        width: 16,
        height: 16,
        bgcolor: appTheme.palette.common.black,
        borderRadius: "50%",
    },
    icon: { width: "100%", height: "auto", maxWidth: 150, maxHeight: 150, objectFit: "contain" },
} as const;